interface UserInfo {
  management?: string;
  [key: string]: any;
}

export const getUserInfo = (): UserInfo | null => {
  const stored = localStorage.getItem('userInfo');
  return stored ? JSON.parse(stored) : null;
};
